import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../services/login/login.service';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../services/authentication/authentication.service';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { LocalStorageService } from 'src/services/local-storage/local-storage.service';
import { SessionStorageService } from 'src/services/session-storage/session-storage.service';
import { UserService } from 'src/services/user/user.service';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss']
})
export class LoginPageComponent implements OnInit {
  public form: FormGroup;
  public loading = false;
  public errorMessage?: string;
  public attemptedSubmit = false;

  constructor(
    private loginService: LoginService,
    private router: Router,
    private auth: AuthenticationService,
    private localStorage: LocalStorageService,
    private sessionStorage: SessionStorageService,
    private userService: UserService
  ) { }

  ngOnInit() {
    this.form = new FormGroup({
      email: new FormControl('', [Validators.required]),
      password: new FormControl('', [Validators.required])
    });
  }

  get email(): FormControl {
    return this.form.get('email') as FormControl;
  }

  get password(): FormControl {
    return this.form.get('password') as FormControl;
  }

  async onLoginClick() {
    this.attemptedSubmit = true;
    if (this.form.invalid) {
      return;
    }
    const email = this.email.value;
    const password = this.password.value;
    this.loading = true;
    try {
      const response = await this.login(email, password);
      if (response === true) {
        this.sessionStorage.clearItem("workspace-list");
        var language = this.sessionStorage.getItem('language');
        if(language && language!='en'){
          window.location.pathname=`/${language}/home`;
        }else{
          this.router.navigate(['/home']);
        }
      } else {
        console.log(response);
        this.errorMessage = "Unexpected server response";
      }
    } catch(err) {
      this.attemptedSubmit = false; // Supress form validation errors
      this.errorMessage = ((err && err.message ? err.message : err) || "Unknown error").toString();
    }
    this.loading = false;
  }

  async login(email: string, password: string): Promise<true> {

    const {expireIn, token, name, isAdmin,language,refreshToken} = await this.loginService.login(email, password);

    this.auth.login({email, name, token, expireIn, isAdmin,language,refreshToken});

    return true;
  }

  async resend(){
    try{
      await this.userService.resend(this.email.value);
      this.errorMessage = `Mail sent! Please verify your mail box`
    }
    catch(e)
    {
      this.errorMessage = e.message;
      console.log(e.message)
    }
  }

  async onForgotClick(event) {
    const email = this.email.value;
    this.router.navigate(email ? ['/password/forgot', email] : ['/password/forgot']);
  }

  onEnterSubmit() {
    // Nothing to do
  }
}
